import React, {Component, Fragment} from "react";

import { Grid, Row, Col } from 'react-bootstrap';
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setPage } from "../../../store/actions/FormAction";


/*
    Documents view that displays the Document Uploader page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
    SVGs need to have the xml attributes removed
*/
class PaymentSchedule extends Component {
  constructor(props){
    super(props);
    this.toggleSchedule = this.toggleSchedule.bind(this);
    this.handleStatuses = this.handleStatuses.bind(this);
    this.modalOpen = false;
    this.scheduleOpen = false;
  }
  componentDidMount() {
    this.props.updateForm("pagename", "Payment Schedule");
    this.props.setPage("paymentschedule");
    //For Testing Purposes
    if (this.props.st.length < 1){
      this.props.updateForm("fn", "John");
      this.props.updateForm("ln", "Doe");
      this.props.updateForm("address", "123 Main St, Columbus, OH, 34567");
      this.props.updateForm("street", "123 Main St");
      this.props.updateForm("city", "Columbus");
      this.props.updateForm("st", "Ohio");
      this.props.updateForm("stt", "OH");
      this.props.updateForm("zip", "34567");
      this.props.updateForm("eml", "jonathandoe@johndoeacct.com");
      this.props.updateForm("phn", "512-321-4567");
      this.props.updateForm("ismobile", true);
      this.props.updateForm("ssn", "XXX-XX-1234");
      this.props.updateForm("co", "ABCD Co");
      this.props.updateForm("cophn", "412-321-4567");
      this.props.updateForm("payfrequency", "Bi-Weekly");
      this.props.updateForm("payamount", "1643.56");
      this.props.updateForm("accounttype", "Checking");
      this.props.updateForm("bankaccount", "81214654564");
      this.props.updateForm("routingnum", "012100564");
      this.props.updateForm("sig1", "1234");
      this.props.updateForm("sig2", "1234");
      this.props.updateForm("sig3", "1234");
      this.props.updateForm("ref1fn", "Mary");
      this.props.updateForm("ref1ln", "Doe");
      this.props.updateForm("ref1phn", "512-321-4567");
      this.props.updateForm("ref1rel", "Sister");
      this.props.updateForm("ref2fn", "Jenny");
      this.props.updateForm("ref2ln", "Appleseed");
      this.props.updateForm("ref2phn", "312-555-4863");
      this.props.updateForm("ref2rel", "Cousin");
    }
  }

  handleStatuses(e){

    if (!this.modalOpen) {
      this.modalOpen = true;
      document.getElementById("custommodal").classList.remove("hidden");
      document.getElementById("modalinner").classList.remove("noheight");
      document.getElementById("modalinner").classList.add("slidemodal");
    } else {
      this.modalOpen = false;
      document.getElementById("custommodal").classList.add("hidden");
      document.getElementById("modalinner").classList.add("noheight");
      document.getElementById("modalinner").classList.remove("slidemodal");
    }
  }

  toggleSchedule(e){

    if (!this.scheduleOpen) {
      this.scheduleOpen = true;
      [].forEach.call( document.querySelectorAll('.completeschedule'), function(el) {
        el.classList.remove("hidden");
      });
      document.getElementById("viewcompletebtn").innerHTML = "Hide Complete Schedule";
      document.getElementById("showcaret").classList.add("caretup");
    } else {
      this.scheduleOpen = false;
      [].forEach.call( document.querySelectorAll('.completeschedule'), function(el) {
        el.classList.add("hidden");
      });
      document.getElementById("viewcompletebtn").innerHTML = "View Complete Schedule";
      document.getElementById("showcaret").classList.remove("caretup")
    }
  }

  render() {

      return (
        <Fragment>
          <div id="dashboard2">
            <div className="dashheader">
              {this.props.pagename}
            </div>
            <div className="container">
              <p className="buttontitle">Current Payment Schedule</p>
              <Grid className="loantabletitle">
                <Row>
                  <Col xs={4} style={{borderRight:'1px solid #fff'}} className="text-center">
                    <strong>Payment Date</strong>
                  </Col>
                  <Col xs={4} style={{borderRight:'1px solid #fff'}} className="text-center">
                    <strong>Payment Amount</strong>
                  </Col>
                  <Col xs={4} className="text-center">
                    <p style={{verticalAlign:'middle',paddingTop:'8px'}}>
                      <strong>Status </strong>
                      <svg width="16px" viewBox="0 0 13 13" onClick={this.handleStatuses} style={{marginLeft:'3px',marginBottom:'-3px'}}>
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-273.000000, -161.000000) translate(272.000000, 160.000000)">
                          <polygon id="Shape" points="0 0 15 0 15 15 0 15"></polygon>
                          <path d="M7.5,1.25 C4.05,1.25 1.25,4.05 1.25,7.5 C1.25,10.95 4.05,13.75 7.5,13.75 C10.95,13.75 13.75,10.95 13.75,7.5 C13.75,4.05 10.95,1.25 7.5,1.25 L7.5,1.25 Z M8.125,10.625 L6.875,10.625 L6.875,6.875 L8.125,6.875 L8.125,10.625 L8.125,10.625 Z M8.125,5.625 L6.875,5.625 L6.875,4.375 L8.125,4.375 L8.125,5.625 L8.125,5.625 Z" id="Shape" fill-opacity="0.9" fill="#5ABA46"></path>
                        </g>
                      </svg>
                    </p>
                  </Col>
                </Row>
              </Grid>
              <Grid className="loantablebody" style={{padding:'0 15px'}}>
                <Row>
                  <Col xs={4} className="text-center">
                    05/29/2018
                  </Col>
                  <Col xs={4}className="text-center">
                    $1072.14
                  </Col>
                  <Col xs={4} className="text-center">
                    <span style={{color:'#5ABA46'}}>Cleared</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={4} className="text-center">
                    06/13/2018
                  </Col>
                  <Col xs={4} className="text-center">
                    $71.54
                  </Col>
                  <Col xs={4} className="text-center">
                    <span style={{color:'#1565C0'}}>Pending</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={4} className="text-center">
                    06/20/2018
                  </Col>
                  <Col xs={4} className="text-center">
                    $71.09
                  </Col>
                  <Col xs={4} className="text-center">
                    <span>Scheduled</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={4} className="text-center">
                    07/12/2018
                  </Col>
                  <Col xs={4}className="text-center">
                    $72.14
                  </Col>
                  <Col xs={4} className="text-center">
                    Scheduled
                  </Col>
                </Row>
                <Row className="completeschedule hidden">
                  <Col xs={4} className="text-center">
                    07/29/2018
                  </Col>
                  <Col xs={4}className="text-center">
                    $72.14
                  </Col>
                  <Col xs={4} className="text-center">
                    Scheduled
                  </Col>
                </Row>
                <Row className="completeschedule hidden">
                  <Col xs={4} className="text-center">
                    08/13/2018
                  </Col>
                  <Col xs={4} className="text-center">
                    $71.54
                  </Col>
                  <Col xs={4} className="text-center">
                    Scheduled
                  </Col>
                </Row>
                <Row className="completeschedule hidden">
                  <Col xs={4} className="text-center">
                    08/20/2018
                  </Col>
                  <Col xs={4} className="text-center">
                    $71.09
                  </Col>
                  <Col xs={4} className="text-center">
                    <span>Scheduled</span>
                  </Col>
                </Row>
                <Row className="completeschedule hidden">
                  <Col xs={4} className="text-center">
                    09/13/2018
                  </Col>
                  <Col xs={4} className="text-center">
                    $71.09
                  </Col>
                  <Col xs={4} className="text-center">
                    <span>Scheduled</span>
                  </Col>
                </Row>

                <Row onClick={this.toggleSchedule}>
                  <Col xs={12} className="text-center">
                    <p id="viewcompletebtn" style={{color:'#1565c0'}}>View Complete Schedule</p>
                    <svg id="showcaret" width="20px" viewBox="0 0 20 20">
                      <g strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-39.000000, -368.000000) translate(49.000000, 378.000000) scale(1, -1) translate(-49.000000, -378.000000) translate(40.000000, 369.000000)" stroke="#1565c0">
                        <circle className="Oval-3" strokeWidth="0.5" cx="9" cy="9" r="9"></circle>
                        <polyline className="downarrow" strokeWidth="1.0546875" strokeLinecap="round" points="6.19272374 10.2351675 8.90261101 7.47070736 11.6124983 10.2351675"></polyline>
                      </g>
                    </svg>
                  </Col>
                </Row>

              </Grid>
            </div>
          </div>

          <div id="custommodal" className="custommodal hidden" onClick={this.handleStatuses}>
            <div id="modalinner" className="modalinner noheight">
              <div className="padtop text-center">
                <svg width="26px" viewBox="0 0 13 13">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-273.000000, -161.000000) translate(272.000000, 160.000000)">
                    <polygon id="Shape" points="0 0 15 0 15 15 0 15"></polygon>
                    <path d="M7.5,1.25 C4.05,1.25 1.25,4.05 1.25,7.5 C1.25,10.95 4.05,13.75 7.5,13.75 C10.95,13.75 13.75,10.95 13.75,7.5 C13.75,4.05 10.95,1.25 7.5,1.25 L7.5,1.25 Z M8.125,10.625 L6.875,10.625 L6.875,6.875 L8.125,6.875 L8.125,10.625 L8.125,10.625 Z M8.125,5.625 L6.875,5.625 L6.875,4.375 L8.125,4.375 L8.125,5.625 L8.125,5.625 Z" id="Shape" fill-opacity="0.9" fill="#5ABA46"></path>
                  </g>
                </svg>
              </div>
              <h2 className="padtop">Payment Statuses</h2>
              <p className="padtop"><strong>Cleared:</strong> Your payment has been recieved by MoneyKey. </p>
              <p className="padtop"><strong>Pending:</strong> Your payment has been sent to MoneyKey, but has not yet cleared. </p>
              <p className="padtop"><strong>Returned:</strong> Your payment was not processed as it was returned by your bank. </p>
              <p className="padtop padbottom"><strong>Scheduled:</strong> Your payment is upcoming and is expected to be processed on your Payment Date.</p>
            </div>
          </div>
        </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    st: state.FormReducer.st,
    page: state.FormReducer.page,
    pagename: state.FormReducer.pagename,
    lateststep: state.FormReducer.lateststep,
    currentstep: state.FormReducer.currentstep
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setPage: (page) => dispatch(setPage(page))
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSchedule);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/PaymentSchedule.js